import {
  SELECT_PROVIDER_ID,
  INVITE_CREATE_REQUEST_FAIL,
  INVITE_CREATE_REQUEST_SUCCESS,
  RESET_PROVIDERS,
  INVITE_DELETE
} from "../action.types";
import InitialState from "../initial.state";

export default (state = InitialState.providersSelected, action) => {
  switch (action.type) {
    case SELECT_PROVIDER_ID:
      return [...action.providerId];
    case INVITE_CREATE_REQUEST_SUCCESS:
      return action.payload;
    case INVITE_CREATE_REQUEST_FAIL:
      return state;
    case INVITE_DELETE:
      return state
    case RESET_PROVIDERS:
      return InitialState.providersSelected;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/providerSelected/providersSelected.reducer.js